import React from "react";
import { motion } from "framer-motion";
import { Chart } from "react-google-charts";
import { FaCheckCircle, FaEnvelope, FaPhone } from "react-icons/fa";
import styles from "./Home.module.css";
import Services from "../Components/Home/Services";
import WhyChooseUs from "../Components/Home/WhyChooseUs";

const chartData = [
    ["Category", "Value"],
    ["AI & ML", 25],
    ["Data Analytics", 30],
    ["Software Dev", 35],
    ["Cybersecurity", 10],
];

const chartOptions = {
    pieHole: 0.4,
    is3D: false,
    backgroundColor: "transparent",
    legend: { position: "bottom", color : 'white', textColor : 'white', fontColor : 'white' },
    
};

const Home = () => {
    return (
        <div className={styles.container}>
            <motion.h1 className={styles.heading} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
                Welcome to Quantabiz
            </motion.h1>

            <motion.p className={styles.subheading} initial={{ x: -100 }} animate={{ x: 0 }} transition={{ duration: 1 }}>
                Empowering Businesses with Data-Driven Intelligence
            </motion.p>

            <motion.div className={styles.chartContainer} initial={{ scale: 0.5 }} animate={{ scale: 1 }} transition={{ duration: 1 }}>
                <Chart chartType="PieChart" data={chartData} options={chartOptions} width="100%" height="340px" />
            </motion.div>
            <div>
                <p>
                    Quantabiz is a leading technology firm specializing in data-driven solutions, AI-powered analytics, and strategic business transformation.
                </p>
                <p>
                    Our mission is to help businesses harness the power of data to make informed decisions, optimize operations, and achieve sustainable growth.
                </p>
            </div>
            <Services />
            <WhyChooseUs />
        </div>
    );
};

export default Home;
